import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-revenue-poc',
  standalone: false,
  templateUrl: './revenue-poc.component.html',
  styleUrls: ['./revenue-poc.component.scss']  // <-- fixed here
})
export class RevenuePocComponent implements OnInit , OnDestroy {
  @Input() step: any;
  @Input() id: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
 @Output() stepCompleted = new EventEmitter<void>();
   private subscriptions = new Subscription();
  payload: { proposal_id: any; proposal_name: any } = { proposal_id: null, proposal_name: null };

  vendorColumns: string[] = [];
  allColumns: string[] = [];

  evaluationData: any[] = [];

  totalRow: any = {};
  passingScoreRow: any = {};
  overallEvaluationRow: any = {};

  signers = [];

  chairman = {
    name: 'Ankush Kaushal', rank: 'Captain', role: 'Chairman'
  };
  criteriaData: any[] = [];
  userID: any;

  constructor(
    private messageService: MessageService,
    private route: ActivatedRoute,
    private api: ApiService
  ) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.payload = {
        proposal_id: params['id'],
        proposal_name: params['name']
      };
    });
    // this.getPoC();
    this.fetchVendorsAndData();
    this.getCommittee() ;
  }
   ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
    goToNextStep(){
     this.stepCompleted.emit();
  }
  tableData: any[] = [];
  vendorList: any
  // fetchVendorsAndData() {
  //   this.api.getAPI(`/revenue/proof-concept/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
  //     .subscribe((response: any) => {
  //       const criteriaMap = new Map<number, any>();
  //       const vendorMap = new Map<string, number>(); // Map to hold vendorName -> vendorId

  //       this.vendors = [];

  //       // Build vendor list and vendorMap
  //       for (const vendorName of Object.keys(response)) {
  //         const vendorDataArray = response[vendorName];
  //         if (vendorDataArray.length > 0) {
  //           const vendorObj = vendorDataArray[0].vendor;
  //           if (!vendorMap.has(vendorObj.name)) {
  //             vendorMap.set(vendorObj.name, vendorObj.id);
  //             this.vendors.push({
  //               id: vendorObj.id,     // Real vendor ID
  //               name: vendorObj.name  // Display name
  //             });
  //           }
  //         }
  //       }
  //       // Initialize editable state
  //       this.isVendorEditable = {};
  //       this.vendors.forEach(vendor => {
  //         this.isVendorEditable[vendor.id] = false;
  //       });

  //       // Process criteria data
  //       for (const vendorName of Object.keys(response)) {
  //         for (const item of response[vendorName]) {
  //           const c = item.criteria;
  //           const id = c.id;
  //           const criteriaId = item.criteria.id;
  //           const vendorId = item.vendor.id;
  //           const evaluationId = item.id;
  //           if (!criteriaMap.has(id)) {
  //             criteriaMap.set(id, {
  //               srNo: criteriaMap.size + 1,
  //               evaluationElement: c.name,
  //               deliverables: c.sub_name,
  //               total: c.total_mark,
  //               minMarks: c.cut_off,
  //               vendorMarks: {},  // rename marks to vendorMarks to be consistent with template
  //               evaluationIds: {},
  //               criteriaId: id
  //             });
  //           }

  //           // const row = criteriaMap.get(id);
  //           // row.vendorMarks[vendorName] = item.mark ?? null;
  //           const row = criteriaMap.get(criteriaId);
  //           row.vendorMarks[vendorId] = item.mark;
  //           row.evaluationIds[vendorId] = evaluationId;
  //         }
  //       }

  //       this.evaluationData = Array.from(criteriaMap.values());
  //       this.editFields = { total: false, minMarks: false };

  //       // Reset qualification statuses
  //       this.evaluationData.forEach(row => {
  //         row.qualificationStatus = {};
  //       });
  //     });
  // }

fetchVendorsAndData() {
const sub =  this.api.getAPI(`/revenue/proof-concept/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
    .subscribe((response: any) => {
      const criteriaMap = new Map<number, any>();
      const vendorMap = new Map<string, number>();
      const vendorQualificationStatus = new Map<number, string>();

      this.vendors = [];

      for (const vendorName of Object.keys(response)) {
        const vendorDataArray = response[vendorName];
        if (vendorDataArray.length > 0) {
          const vendorObj = vendorDataArray[0].vendor;

          if (!vendorMap.has(vendorObj.name)) {
            vendorMap.set(vendorObj.name, vendorObj.id);
            this.vendors.push({
              id: vendorObj.id,
              name: vendorObj.name
            });
          }

          // ✅ Sort by criteria.sequence or by item.id to get the latest one
          vendorDataArray.sort((a, b) => a.criteria.sequence - b.criteria.sequence);

          for (let i = 0; i < vendorDataArray.length; i++) {
            const item = vendorDataArray[i];
            const c = item.criteria;
            const criteriaId = c.id;
            const vendorId = vendorObj.id;
            const evaluationId = item.id;

            // ✅ Only assign qualification status on the last iteration
            if (i === vendorDataArray.length - 1) {
              const qualificationStatus = item.vendor_status ?? null;
              vendorQualificationStatus.set(vendorId, qualificationStatus);
            }

            if (!criteriaMap.has(criteriaId)) {
              criteriaMap.set(criteriaId, {
                srNo: criteriaMap.size + 1,
                evaluationElement: c.name,
                deliverables: c.sub_name,
                total: +c.total_mark,
                minMarks: +c.cut_off,
                vendorMarks: {},
                evaluationIds: {},
                criteriaId: criteriaId
              });
            }

            const row = criteriaMap.get(criteriaId);
            row.vendorMarks[vendorObj.id] = item.mark;
            row.evaluationIds[vendorObj.id] = evaluationId;
          }
        }
      }

      this.evaluationData = Array.from(criteriaMap.values());
      this.editFields = { total: false, minMarks: false };

      // ✅ Convert to plain object for template usage
      this.qualificationStatus = Object.fromEntries(vendorQualificationStatus);
    });
     this.subscriptions.add(sub);
}



  isVendorEditable: { [key: number]: boolean } = {};
  editFields = {
    total: false,
    minMarks: false
  };
  toggleEdit(field: 'total' | 'minMarks') {
    this.editFields[field] = !this.editFields[field];
  }
isVendorCellEditable: { [vendorId: number]: { [rowIndex: number]: boolean } } = {};

  // toggleVendorEdit(vendorId: number) {
  //   this.isVendorEditable[vendorId] = !this.isVendorEditable[vendorId];
  // }
  toggleVendorEdit(vendorId: number, rowIndex: number) {
  if (!this.isVendorCellEditable[vendorId]) {
    this.isVendorCellEditable[vendorId] = {};
  }

  this.isVendorCellEditable[vendorId][rowIndex] = true;
}

  saveChanges() {
    const payload = [];
    this.evaluationData.forEach((row, criteriaIndex) => {
      this.vendors.forEach(vendor => {
        payload.push({
          proposal_step: 1327,
          criteria: criteriaIndex + 1, // adjust if real ID differs
          vendor: vendor.id,
          mark: row.vendorMarks[vendor.id]
        });
      });
    });
    //console.log('Saved payload:', payload);
  }

  qualifyVendor(row: any, vendor: any) {
    row.qualificationStatus = row.qualificationStatus || {};
    row.qualificationStatus[vendor.id] = true;
    //console.log(`Vendor ${vendor.name} is qualified for ${row.evaluationElement}`);
  }
  qualificationStatus: { [vendorId: string]: string } = {}; // to track selected status

  updateQualificationStatus(vendor: any, status: 'Qualify' | 'Disqualify') {
    const matchedVendor = this.vendors.find(v => v.name === vendor.name);
    //console.log(matchedVendor)

    if (!matchedVendor) {
      console.error(`Vendor with name "${vendor.name}" not found in vendors list.`);
      return;
    }

    // Store the status
    this.qualificationStatus[matchedVendor.id] = status;

    const payload = {
      vendor_status: status
    };
   const sub = this.api.putAPI(`/revenue/proof-concept/?vendor_id=${matchedVendor.id}`, payload)
      .subscribe({
        next: (res) => {
          //console.log(`Vendor ${vendor.name} status updated to ${status}`, res);
        },
        error: (err) => {
          console.error('Error updating vendor status', err);
        }
      });
       this.subscriptions.add(sub);
  }
  getQualification(){

  }
  getTotalOverallMarks(): number {
  return this.evaluationData.reduce((sum, row) => sum + Number(row.total || 0), 0);
}

getTotalMinimumMarks(): number {
  return this.evaluationData.reduce((sum, row) => sum + Number(row.minMarks || 0), 0);
}

getTotalForVendor(vendorId: number): number {
  return this.evaluationData.reduce((sum, row) => {
    const mark = Number(row.vendorMarks?.[vendorId] || 0);
    return sum + mark;
  }, 0);
}
validateVendorMark(row: any, vendorId: number): void {
  const enteredMark = Number(row.vendorMarks[vendorId]);
  const totalMark = Number(row.total);

  if (enteredMark > totalMark) {
    // alert(`Entered mark (${enteredMark}) exceeds the total mark (${totalMark}) for this criteria.`);
    row.vendorMarks[vendorId] = totalMark;
  } else if (enteredMark < 0) {
    // alert(`Marks cannot be negative.`);
    row.vendorMarks[vendorId] = 0;
  }
}

  logMark(row: any, vendorId: number , rowIndex: number) {
    const criteriaId = row.criteriaId; // helper to find the criteria id
    const mark = row.vendorMarks[vendorId];
    const evaluationId = row.evaluationIds[vendorId];
    //console.log('Criteria ID:', criteriaId);
    //console.log('Vendor ID:', vendorId);
    //console.log('Entered Mark:', mark);
    const payload = {
      proposal: this.payload.proposal_id,
      criteria: criteriaId,
      vendor: vendorId,
      mark: mark,
    };

   const sub = this.api.putAPI(`/revenue/proof-concept/${evaluationId}/`, payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Marks saved Successfully' });
    })
     this.subscriptions.add(sub);
    this.isVendorCellEditable[vendorId][rowIndex] = false;
  }

  getPoC() {
   const sub = this.api.getAPI(`/transaction/poc-criteria/${this.payload.proposal_id}/list/`).subscribe((res: any) => {
      this.stages = res
      // this.messageService.add({severity:'success', summary: 'Success', detail: res.message || 'Criteria Skipped Successfully'});
    })
     this.subscriptions.add(sub);
  }


  vendors: any
  //   = [
  //       'ILIZIEN Pvt. Ltd.',
  //       'Company 2',
  //       'Company 3',
  // ];

  criteria = [
    'Technical Compliance with RFP Requirements',
    'System Architecture and Design',
    'Performance and Scalability',
    'Security Features and Compliance',
    'Integration Capabilities',
    'User Experience and Interface Design',
    'Support and Maintenance Plan',
    'Implementation Methodology',
    'Project Timeline and Milestones',
    'Team Qualifications and Experience',

  ];

  eoiData: any;
  apiUrl = environment.APIUrl
  items = [
    {
      label: 'POC Shortlisting',
      command: (event: any) => this.getStep1()
    },
    {
      label: 'Evaluation',
      command: (event: any) => this.getStep2()
    },


  ];
  PDSactiveIndex = 0;
  isSkipStep: boolean = false;
  currentStage: number = 1;
  stages = []
  onPDSActiveIndexChange(event: number) {
    this.PDSactiveIndex = event;
    if (this.PDSactiveIndex == 1) {
      this.fetchVendorsAndData()
    }
  }
  getStep1() { }
  getStep2() { }
  confirmSkipStage() {
    const skippedStages = this.stages.filter(stage => stage.exists_in_transaction);

    // Step 2: Validate remarks (optional)
    // const missingRemarks = skippedStages.filter(stage => !stage.remark || !stage.remark.trim());
    // if (missingRemarks.length > 0) {
    //   alert('Please provide a reason for all skipped criteria.');
    //   return;
    // }

    // Step 3: Process the skipped stages
    const payload = skippedStages.map(stage => ({
      proposal: this.payload.proposal_id,
      criteria: stage.id,
      name: stage.name,
      sequence: stage.sequence,
      skipped: false,
      remark: stage.remark
    }));

    //console.log('Selected Skipped Stages:', payload);
    this.api.postAPI(`/transaction/poc-criteria/${this.payload.proposal_id}/list/`, payload).subscribe((res: any) => {
      //console.log(res);
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Criteria added Successfully' });
      this.PDSactiveIndex = 1;
      this.fetchVendorsAndData();
    })
  }
    getCommittee() {
    const sub = this.api.getAPI(`/transaction/committee/?proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
     this.signers = res[0].members
    });
    this.subscriptions.add(sub);
  }
  capitalize(value: string): string {
  if (!value) return '';
  value = value.toLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

}
